import {CSSProperties, FC} from 'react';


export interface IIconCancelNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCancelNissan: FC<IIconCancelNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M16.058 6.32a1.167 1.167 0 0 1 1.605 0c.216.206.337.487.337.78 0 .294-.121.575-.337.781L13.348 12l4.315 4.119c.216.206.337.487.337.78 0 .294-.121.575-.337.781a1.167 1.167 0 0 1-1.605 0l-4.086-3.892-4.03 3.892a1.167 1.167 0 0 1-1.605 0A1.081 1.081 0 0 1 6 16.9c0-.294.121-.575.337-.781l4.263-4.12-4.263-4.118a1.085 1.085 0 0 1-.33-.656L6 7.1c0-.293.121-.574.337-.78a1.167 1.167 0 0 1 1.605 0l4.03 3.892 4.086-3.892Z" clipRule="evenodd" />
        </svg>
    );
};
